module.exports = __webpack_public_path__ + "static/media/payment-mandiri.60c2a61a.png";